import { Component, AfterViewInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

declare var $: any; // jQuery — usado pelo `$.ZammadForm()` da biblioteca externa.
declare var ZammadForm: any;
declare var ZammadChat: any;

/**
 * Mantenedor do bridge com a biblioteca Zammad. O conteúdo visível do
 * helpdesk migrou para o `HelpdeskCardComponent` (montado via CDK Overlay
 * pelo `HelpdeskOverlayService`). Este componente continua mountado em
 * `base.component` apenas para:
 *  - servir os âncoras hidden (`#first-contact`, `.open-zammad-chat`,
 *    `#feedback-form-try`, `#zammad-feedback-form`) que o script Zammad
 *    e o card componentizado precisam encontrar no DOM.
 *  - inicializar `ZammadForm` e `ZammadChat` quando o script externo
 *    carrega com sucesso.
 */
@Component({
  selector: 'app-support-button',
  templateUrl: './support-button.component.html',
  styleUrls: ['./support-button.component.scss'],
})
export class SupportButtonComponent implements AfterViewInit {
  constructor(
    private translateService: TranslateService,
  ) {}

  ngAfterViewInit(): void {
    this.loadScript('https://suporte.sbc.org.br/assets/chat/chat-no-jquery.min.js')
      .then(() => this.initZammad())
      .catch(() => {
        // Script bloqueado / cert expirado. O `HelpdeskCardComponent` já
        // detecta a ausência do widget (`.js-chat-open` não aparece) e
        // troca para o modo 'form' com fallback por e-mail.
        console.warn('[support-button] Zammad chat script failed to load; running in offline-help mode.');
      });
  }

  private loadScript(src: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = src;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error('Failed to load ' + src));
      document.body.appendChild(script);
    });
  }

  public initZammad(): void {
    this.translateService
      .get(['title', 'submit', 'messageThanks'].map(v => `help-chat.form.${v}`))
      .subscribe(e => {
        $('#zammad-feedback-form').ZammadForm({
          messageTitle: e['help-chat.form.title'],
          messageSubmit: e['help-chat.form.submit'],
          messageThankYou: e['help-chat.form.messageThanks'],
          modal: true,
        });
        new ZammadChat({
          background: '#1a73e8',
          fontSize: '12px',
          chatId: 1,
          show: false,
          name: 'TESTE',
          // O widget lê `<html lang>` e, se não achar a chave EXATA em
          // `translations`, remove a região (pt-BR → pt). O dicionário do script
          // está sob `pt-br` (minúsculo), então pt-BR/pt não casam → cai no inglês
          // e loga "Translation 'pt' needed!". Passar o idioma em minúsculo casa a
          // chave (pt-br) e usa o dicionário português direto.
          lang: (this.translateService.currentLang || 'pt-BR').toLowerCase(),
        });
      });
  }
}
